import React from 'react';
import css from './insights.less';
import Chart from 'chart.js';
import {getReportColor} from '../../data/report-colors'

type Props = {
    width?: number;
    height?: number;
    labelKey?: string;
    valueKey?: string;
    colorKey?: string;
    data?: any[];
};


export default class PieChart extends React.PureComponent<Props> {
    static defaultProps = {
        width: 400,
        height: 400,
        colorKey: 'color',
        labelKey: 'label',
        valueKey: 'value',
    }

    canvas: any;
    chart: any;

    componentDidMount() {
        const ctx = this.canvas.getContext('2d');
        this.chart = new Chart(ctx, {
            type: 'pie',
            options: {
                legend: {
                    display: false,
                }
            }
        });
        this.refresh();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.data !== this.props.data) {
            this.refresh();
        }
    }

    refresh = () => {

        if (this.props.data) {
            this.chart.data.labels = this.props.data.map((row: AnyRecord) => row[this.props.labelKey!]);

            if (this.chart.data.datasets.length !== 1) {
                this.chart.data.datasets = [{}];
            }

            this.chart.data.datasets[0].data = this.props.data.map((row: AnyRecord) => row[this.props.valueKey!]);
            this.chart.data.datasets[0].backgroundColor = this.props.data.map((row: AnyRecord, idx: number) => row[this.props.colorKey!] ?? getReportColor(idx));

            this.chart.update();
        }

    };

    setCanvas = (n: any) => {
        this.canvas = n;
    };

    render() {
        const {width, height} = this.props;
        return (
            <div className={css.chartContainerWrap}>
                <div className={css.chartContainer} style={{maxWidth: width, maxHeight: height}}>
                    <canvas ref={this.setCanvas} width={width} height={height}/>
                </div>
            </div>
        )
    }
}
